// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3hhcZ","bigColWidth":"Table_bigColWidth__2vpxs","biggerColWidth":"Table_biggerColWidth__1ewim","row":"Table_row__NL9dp","col":"Table_col__uZVll"};